/**
 * Care Plan Service
 * Patient care plan management and tracking API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RecreateWorkItemsByFiltersRequestDto { 
    /**
     * Patient ID to filter care plans
     */
    patientId: string;
    /**
     * Care plan statuses to include (defaults to OPEN only)
     */
    statuses?: Array<RecreateWorkItemsByFiltersRequestDto.StatusesEnum>;
    /**
     * Allow duplicate work items to be created even if similar ones exist
     */
    allowDuplicates?: boolean;
}
export namespace RecreateWorkItemsByFiltersRequestDto {
    export type StatusesEnum = 'open' | 'on-hold' | 'closed';
    export const StatusesEnum = {
        Open: 'open' as StatusesEnum,
        OnHold: 'on-hold' as StatusesEnum,
        Closed: 'closed' as StatusesEnum
    };
}


